export const environment = {
  production: false,
  apiUrl: 'http://localhost:8080/panel-unbrid-back/api',
  shopUrl: 'https://dev-shop.unbrid.com',
  ntoUri: "https://dev-nto.unbrid.com/",
  appUnbrid:"http://localhost:4200/"
};
